// CommunityForm.js
import React, { useEffect, useState } from "react";
import { sendApplication } from "../api/general.js";
import DateObject from "react-date-object";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import "../css/ApplicationForm.css";

const MAX_FILE_SIZE = 4 * 1024 * 1024;   // 4 MB

function ApplicationForm({ onCreated, onCancel, content, setlang }) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [major, setMajor] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const [yoe, setYoe] = useState("");
    const [goalProf, setGoalProf] = useState("");
    const [goalTarget, setGoalTarget] = useState("");
    const [expectationsEnv, setExpectationsEnv] = useState("");
    const [expectationsHr, setExpectationsHr] = useState("");
    const [highestEdu, setHighestEdu] = useState("");
    const [currentAct, setCurrentAct] = useState("");
    const [strenghtWeakness, setStrenghtWeakness] = useState("");
    const [residency, setResidency] = useState("");
    const [dob, setDob] = useState("");
    const [resumeFile, setresumeFile] = useState([]); 
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null);
    const [consoleError, setConsoleError] = useState("");
    const [error, setError] = useState("");
    const [resError, setResError] = useState("");
    const [confirm, setConfirm] = useState("");
  

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setError("");
      setResError("");

      if (resumeFile.size > MAX_FILE_SIZE) {
        setLoading(false);
        setresumeFile(null);
        if (setlang === "en" ) {
          setResError(`Your resume exceeds max size (${MAX_FILE_SIZE / (1024 * 1024)}MB)`);
          alert(`Your resume exceeds max size (${MAX_FILE_SIZE / (1024 * 1024)}MB)`);

        } else {
          setResError(`حجم فایل رزومه نمی‌تواند بیشتر از ${MAX_FILE_SIZE / (1024 * 1024)}MB باشد`);
          alert(`حجم فایل رزومه نمی‌تواند بیشتر از ${MAX_FILE_SIZE / (1024 * 1024)}MB باشد`);
        }

      } else { 
        
        try {
          const newApplication = await sendApplication ({
            firstName,
            lastName,
            major,
            contactPhone,
            contactEmail,
            jobTitle,
            yoe,
            goalProf,
            goalTarget,
            expectationsEnv,
            expectationsHr,
            highestEdu,
            currentAct,
            strenghtWeakness,
            residency,
            dob,
            resumeFile, 
          });

          if (onCreated) onCreated(newApplication);
          setFirstName("");
          setLastName("");
          setMajor("");
          setContactPhone("");
          setContactEmail("");
          setJobTitle("");
          setYoe("");
          setGoalProf("");
          setGoalTarget("");
          setExpectationsEnv("");
          setExpectationsHr("");
          setHighestEdu("");
          setStrenghtWeakness("");
          setCurrentAct("");
          setResidency("");
          setDob(null);
          setresumeFile(null);

          if (setlang === "en") {
            alert("Thank you for your application, you'll be contacted in coming days");
            setConfirm(`Your application successfully received`);
          } else {
            alert("سپاس از علاقه شما برای پیوستن به تیم ما، با شما در روزهای آینده در تماس خواهیم بود");
            setConfirm(`درخواست شما با موفقیت دریافت شد`);
          }
      
        } catch (err) {
          if (err.response && err.response.data) {
            setError(JSON.stringify(err.response));
          } else {
            setError(err.message);
          }
        } finally {
          setLoading(false);
          setresumeFile(null);
        }
      }
    };

    return (
      <div className="Appli-container">
        <form onSubmit={handleSubmit}
        className="Appli-form"
        style={{display:'grid', width:'100%'}}>

          <h1>رزومه شما</h1>
          {error && <p className="Appli-form-error">{setlang === "en" ? "Please review information provided":"لطفا اطلاعات رو کامل وارد کن"}</p>}
          {resError && <p className="Appli-form-error" style={{color:"#a0130e"}}>{resError}</p>}
            <div>
              <label className="Appli-com-label">
                نام
              </label>
              <input
                type="text"
                value={firstName}
                style={{gridColumn: 'span 2'}}
                onChange={(e) => setFirstName(e.target.value)}
                
                />
            </div>
            <div>
              <label className="Appli-com-label">
                نام خانوادگی
              </label>
              <input
                value={lastName}
                style={{gridColumn: 'span 2'}}
                onChange={(e) => setLastName(e.target.value)}
                
                />
            </div>
            <div>
              <label className="Appli-com-label">
              موبایل 
              </label>
              <input
                value={contactPhone}
                style={{gridColumn: 'span 2'}}
                onChange={(e) => setContactPhone(e.target.value)}
                
                />
            </div>
            <div>
              <label className="Appli-com-label">
                ایمیل
              </label>
              <input
                value={contactEmail}
                style={{gridColumn: 'span 2'}}
                onChange={(e) => setContactEmail(e.target.value)}
                
              />
            </div>
            <div>
              <label className="Appli-com-label">
                بالاترین مدرک تحصیلی
              </label>
              <input
                value={highestEdu}
                style={{gridColumn: 'span 2'}}
                onChange={(e) => setHighestEdu(e.target.value)}
                
              />
            </div>
            <div>
              <label className="Appli-com-label">
                محل اقامت
              </label>
              <input
                value={residency}
                style={{gridColumn: 'span 2'}}
                onChange={(e) => setResidency(e.target.value)}
                
              />
            </div>
            <div>
              <label className="Appli-com-label">
               {setlang==="en"? "Select Position" :"عنوان موقعیت"}
              </label>
              <select  onChange={(e) => setJobTitle(e.target.value)}  placeholder="Position" style={{height:"2rem", fontSize:"0.8rem", padding:"0"}} required>
                  {Object.values(content.positions).map((jobs,id) => ( 
                    <option key={id} value={jobs.T}>{jobs.T}</option>
                  ))}
              </select>
            </div>  

            <div>
              <label className="Appli-com-label">
                تاریخ تولد
              </label>
              <DatePicker
                calendar={persian}
                locale={setlang==="en"?persian_en:persian_fa}
                format="YYYY/MM/DD"
                value={dob ? new DateObject(new Date(dob)) : null}
                onChange={(e) => {
                  if (!dob) return;
                  setDob(e.target.value.toDate().toISOString().split("T")[0]);
                }}
                style={{height:"2rem", textAlign:"center"}}
              />
            </div>

            <div style={{gridColumn:'1/-1', marginTop:'5px'}}>
              <label className="Appli-com-label">
                زمینه‌ی تخصصی / تجربه کاری
              </label>
              <textarea
                value={major}
                style={{ height:'3.5rem' ,textAlign:'right', padding:'10px', minWidth:'95%', MaxWidth:'370px', margin:'9px', direction:'rtl'}}
                onChange={(e) => setMajor(e.target.value)}
                
              />
            </div>
            <div style={{gridColumn:'1/-1'}}>
              <label className="Appli-com-label">
              علاقه‌ داری چه هدف‌هایی رو در این موقعیت دنبال کنی؟
              </label>
              <textarea
                value={goalProf}
                style={{ height:'3.5rem' ,textAlign:'right', padding:'10px', minWidth:'95%', MaxWidth:'370px', margin:'9px', direction:'rtl'}}
                onChange={(e) => setGoalProf(e.target.value)}
                
              />
            </div>
            <div style={{gridColumn:'1/-1'}}>
              <label className="Appli-com-label">
             محیط کاری ایده‌آل از نظرت به چه شکل تعریف میشه؟
              </label>
              <textarea
                value={expectationsEnv}
                style={{ height:'3.5rem' ,textAlign:'right', padding:'10px', minWidth:'95%', MaxWidth:'370px', margin:'9px', direction:'rtl'}}
                onChange={(e) => setExpectationsEnv(e.target.value)}
                
              />
            </div>
            <div className="Appli-media-upload">
              <label style={{direction:"rtl"}}>
              بارگذاری رزومه  (کمتر از ۴MB) 
              </label> 
              <input
                type="file"
                accept="resume/*"
                onChange={(e) => setresumeFile(e.target.files[0])} 
                
                />
            </div>
            {confirm && <p className="Appli-form-confi">{confirm}</p>}

          <div className="Appli-button-container">
            <button className="" type="submit" 
            disabled={loading}
            >
              {loading ? "در حال ارسال ..." : "ارسال"}
            </button>
          </div>

        </form>
      </div>
    );
  }
  
  export default ApplicationForm;